import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GenerateCreditNoteConfirmationComponent } from '../generate-credit-note-confirmation/generate-credit-note-confirmation.component';
import { utcToZonedTime, format } from 'date-fns-tz';
import { es } from 'date-fns/locale';
import { ReportsService } from 'src/app/services/reports.service';
@Component({
  selector: 'app-details-transaction',
  templateUrl: './details-transaction.component.html',
  styleUrls: ['./details-transaction.component.scss'],
})
export class DetailsTransactionComponent implements OnInit {
  constructor(
    private modalsSvc: BsModalService,
    private modalRef: BsModalRef,
    private reportsSvc: ReportsService
  ) {}
  transactionInfo!: any;

  ngOnInit(): void {
    
  }

  close() {
    this.modalsSvc.hide();
  }

  createCreditNote() {

    this.modalsSvc.show(GenerateCreditNoteConfirmationComponent, {
      class: 'modal-lg modal-dialog-centered',
      initialState: {
        otherModalRef: this.modalRef,
      },
    });
    
  }

  formatDate(item: string, form: string) {
    let date = new Date(item);
    let zonedDate = utcToZonedTime(date, 'America/Santiago');
    let formatted = format(zonedDate, form, { locale: es });
    return formatted;
  }
  downloadInvoice(voucher:any){
    this.reportsSvc.openDownload(voucher, 'invoice.pdf', false);
  }
}
